import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { offerOrchestrator } from '..';

export interface PricingResponse {
  lineAmount: number;
  trueCentsOnDollar: number;
  trueAPR: number;
  paymentFrequency: string;
  numberOfPayments: number;
  payment: number;
  disbursementAmount: number;
  totalAmountPaidBack: number;
  lender: string;
  modelId: string;
  loanOriginationFee: number;
  averageMonthlyPayment: number;
  term: number;
  totalLoanCost: number;
  monthlyFee: number;
  ppd?: 100 | 25;
}

export interface PricingRequest {
  applicationType: 'RENEWAL' | 'NEW';
  applicationId: string;
  customerData: {
    businessCountry: string;
    businessState: string;
    legalEntity: string;
  };
  loanSpecifics: [
    {
      centsOnDollar: number;
      collectionType: 'ACH';
      line: number;
      oFeePercentage: number;
      paymentFrequency: string;
      product: string;
      productType: string;
      term: number;
    },
  ];
}

export interface GetPricingProps {
  response: PricingResponse | undefined;
  getPricingSending: boolean;
  getPricingError: Error | null;
  getPricing: (args: PricingRequest) => Promise<PricingResponse>;
  mutation: UseMutationResult<PricingResponse, Error, PricingRequest>;
}

export function getPricingDetails(): GetPricingProps {
  const mutation = useMutation({
    mutationFn: (arg: PricingRequest) =>
      offerOrchestrator
        .post<PricingResponse>('/v1/pricing', arg)
        .then((res) => res.data),
    mutationKey: ['getPricing'],
  });

  return {
    response: mutation.data,
    getPricingSending: mutation.isPending,
    getPricingError: mutation.error,
    getPricing: mutation.mutateAsync,
    mutation,
  };
}

export default getPricingDetails;
